import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { useDispatch } from "react-redux";
import { resetToastMessageSettings, setToastMessageContainerClearButtonIsClicked } from "../../stateManagement/reducers";
import styles from "./ToastMessageContainer.module.scss";
import { classNames } from "primereact/utils";

interface IToastMessageContainer {
    windowType?: string;
    position?: any;
}

export default function ToastMessageContainer({ windowType, position = 'top-right' }: IToastMessageContainer) {
    const dispatch = useDispatch()
    const { toastMessageIsShown, toastMessageTitle, toastMessageText, toastMessageType, toastMessageWindowType, toastMessageContainerClearButtonIsClicked } = useAppSelector(state => state.toastMessage)
    const toastRef = useRef<any>(null);
    const lastShownKeyRef = useRef<string | null>(null);
    const positionLabel = position.split('-').map((word) => word[0].toUpperCase() + word.slice(1)).join('');
    const toastClassNames = classNames({
        [styles.toast]: true,
        [styles[`toast${positionLabel}`]]: `toast${positionLabel}` in styles
    });

    useEffect(() => {
        if (toastRef.current && toastMessageIsShown && toastMessageText && toastMessageType && windowType == toastMessageWindowType) {
            const summary = toastMessageType === "error" ? "Ошибка" : "Уведомление"
            const key = `${toastMessageWindowType ?? ''}:${toastMessageType}:${toastMessageText}`;
            lastShownKeyRef.current = key;
            toastRef.current.show({ id: key, key, severity: toastMessageType, summary: toastMessageTitle?.trim() ? toastMessageTitle : summary, detail: toastMessageText, life: 4000 } as any);
            dispatch(resetToastMessageSettings())
        }
    }, [toastMessageIsShown, toastMessageTitle, toastMessageText, toastMessageType, toastMessageWindowType, windowType])

    useEffect(() => {
        if (toastRef.current && toastMessageContainerClearButtonIsClicked) {
            toastRef.current.clear()
            dispatch(setToastMessageContainerClearButtonIsClicked(false))
        }
    }, [toastMessageContainerClearButtonIsClicked])

    return (
        <Toast
            ref={toastRef}
            position={position}
            className={toastClassNames}
        />
    )
}
